export default __webpack_public_path__ + "static/media/large.ccf5abc2.jpg";